import { useParams } from "react-router";

import ResultPage1 from "./pages/ResultPage1";
import ResultPage2 from "./pages/ResultPage2";
import ResultPage3 from "./pages/ResultPage3";

const ResultPage = () => {
  const params = useParams();
  const garbageQtty = Number(params.garbageQtty);

  if (garbageQtty < 30) return <ResultPage1 />;
  else if (garbageQtty < 60) return <ResultPage2 />;
  else return <ResultPage3 />;
};

export default ResultPage;
